<template>
    <header>
        <div class="brandbar">
            <div class="container">
                <img @click="leaveSite" src="@/assets/mississauga-logo.png" alt="Mississauga Logo">
            </div>
        </div>

        <nav class="subnav">
            <div class="container">
                <div class="col-lg-12" style="height: 30px; overflow:visible;">

                    <div style="float:right;">
                        <div  v-if="isLoggedIn">
                            <b-nav pills>
                                <b-dropdown toggle-class='customDropdown' variant='none'><!--no-caret-->
                                    <template #button-content>
                                       <i class="far fa-user-circle"></i>&nbsp;&nbsp;{{ TitleCase(userName)}}
                                    </template>
                                    <b-dropdown-item  v-if="$route.name !== 'Dashboard'"><router-link to="dashboard">Dashboard</router-link></b-dropdown-item>
                                    <b-dropdown-item><router-link to="/forgot-password">Reset password</router-link></b-dropdown-item>
                                    <!--<b-dropdown-divider></b-dropdown-divider>-->
                                    <b-dropdown-item ><a href="javascript:void();" @click="logout" >Sign out</a></b-dropdown-item>
                                </b-dropdown>
                            </b-nav>




                        </div>
                        <div v-else-if="!isLoggedIn">
                        <ul class="nav justify-content-end align-items-center">
                            <li class="nav-item" v-if="!isLoggedIn && $route.name !== 'Login'">
                                <router-link to="/">Login</router-link>
                            </li>
                            <li class="nav-item" v-if="!isLoggedIn && $route.name == 'Login'">
                                <router-link to="/create-account">Create account</router-link>
                            </li>
                            <li class="nav-item" v-if="isLoggedIn">
                                <div>Signed in as {{userName}}</div>
                            </li>
                            <li class="nav-item" v-if="isLoggedIn">
                                <div @click="logout" class="logout">Sign out</div>
                            </li>
                            <li class="nav-item">
                                <router-link to="/forgot-password">Reset password</router-link>
                            </li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <!--
        <div class="col-lg-10 offset-lg-1 d-sm-flex d-block no-gutters pl-3 mt-0">
            <div class="container">
                <BreadCrumb></BreadCrumb>
            </div>       
        </div>
        -->
        <!-- BKUP
        <nav class="subnav">
            <div class="container">
                <div style="overflow:auto;">

                    <div  v-if="isLoggedIn" class="dashboard text-primary"  v-b-popover.hover.right="'To apply for new film permit or retrieving saved applications'" title="Go To Dashboard">
                        <router-link to="dashboard"><i class="fas fa-crosshairs fa-lg"></i></router-link>
                        &nbsp;&nbsp;<router-link to="dashboard">Dashboard</router-link>
                    </div>
                    <div style="float:right;">
                        <ul class="nav justify-content-end align-items-center">
                            <li class="nav-item" v-if="!isLoggedIn && $route.name !== 'Login'">
                                <router-link to="/">Login</router-link>
                            </li>
                            <li class="nav-item" v-if="!isLoggedIn && $route.name == 'Login'">
                                <router-link to="/create-account">Create account</router-link>
                            </li>
                            <li class="nav-item" v-if="isLoggedIn">
                                <div>Signed in as {{userName}}</div>
                            </li>
                            <li class="nav-item" v-if="isLoggedIn">
                                <div @click="logout" class="logout">Sign out</div>
                            </li>
                            <li class="nav-item">
                                <router-link to="/forgot-password">Reset password</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        -->
    </header>
</template>

<script>
//import BreadCrumb from "@/components/PagesRelated/BreadCrumb.vue";
export default {
    name: "Header",
    components: { 
        //BreadCrumb
        },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        userName() {
            const {
                FirstName: first,
                LastName: last
            } = this.$store.getters.getUser;
            return `${first} ${last}`;
        }
    },
    methods: {
        logout() {
            this.$store
                .dispatch("USER_LOGOUT",true)
                .then(this.$router.push("/login"));
        },
        leaveSite() {
            if (
                window.confirm(
                    "You’re about to leave this form, and go to the City homepage. \nSelect “ok” to leave, or “cancel” to remain on this page. "
                )
            ) {
                window.location = "https://web.mississauga.ca";
            }
        },
        TitleCase(strInput)
        {
            return strInput
                .split(' ')
                .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
            /*
            let sentence = string.toLowerCase().split(" ");
            for (let i = 0; i < sentence.length; i++) {
                sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
            }
            
            return sentence.join(" ");
            */
        }        
    }
};
</script>
